document.addEventListener('DOMContentLoaded', () => {
  const videoModal = document.getElementById('videoModal');
  const videoFrame = document.getElementById('videoFrame');
  const closeModal = document.getElementById('closeModal');
  const videoThumbs = document.querySelectorAll('.video-thumb');

  videoThumbs.forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      const videoUrl = thumb.getAttribute('href');
      videoFrame.src = videoUrl;
      videoModal.classList.remove('hidden');
      document.body.classList.add('no-scroll'); // Disable scrolling
    });
  });

  closeModal.addEventListener('click', () => {
    videoModal.classList.add('hidden');
    videoFrame.src = ''; // Stop the video
    document.body.classList.remove('no-scroll'); // Re-enable scrolling
  });

  videoModal.addEventListener('click', (event) => {
    if (event.target === videoModal) {
      videoModal.classList.add('hidden');
      videoFrame.src = '';
      document.body.classList.remove('no-scroll');
    }
  });
});



// WEBPACK FOOTER //
// ./src/javascript/main/videoModal.js